import React from 'react';
import { BaseModel } from '../../models/BaseModel';
import { IModel } from '../../types/models';

const ModuleContext = React.createContext<IModel>(new BaseModel({ render: () => {} }));

export default ModuleContext;
